<template>
  <div class="settings">
    <h1>Settings</h1>
    <div class="language-settings" v-show="languages.length">
      <h2>Language</h2>
      <label for="manifest-file-language">Manifest file language</label>
      <select id="manifest-file-language" v-model="language">
        <option v-for="language in languageOptions" :value="language.code">{{ language.name }}</option>
      </select>
      <p>This option requires page reload after change to apply</p>
    </div>
    <div class="firebase-sync">
      <h2>Sync</h2>
      <firebase-auth></firebase-auth>
    </div>
    <tags-editor></tags-editor>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { isoLanguages } from '@/utils/languages'
  import FirebaseAuth from '../FirebaseAuth.vue'
  import TagsEditor from '../TagsEditor.vue'

  export default {
    name: 'template',
    props: [],
    data () {
      return {}
    },
    computed: {
      languageOptions () {
        return this.languages.map(languageCode => {
          return {
            code: languageCode,
            name: (isoLanguages[languageCode] || isoLanguages[languageCode.split('-')[0]]).nativeName
          }
        })
      },
      language: {
        get () {
          return this.$store.state.destiny.manifest.language
        },
        set (language) {
          this.$store.commit('destiny/manifest/setLanguage', {language})
        }
      },
      ...mapState('destiny/manifest', ['languages']),
      ...mapState('firebaseAuth', ['user'])
    },
    components: {
      TagsEditor,
      FirebaseAuth}
  }
</script>

<style lang="scss">
  @import "../../styles/settings";

  .settings {
    padding: 1rem;
  }

  label {
    font-size: 1rem;
  }

  .firebase-sync {
    ul {
      padding: 0
    }
    li {
      display: block;
      padding: 0;
    }
    button {
      display: inline-block;
      background: $background;
      box-shadow: $default-shadow;
      cursor: pointer;
      img {
        height: 3rem;
        margin-right: 1rem;
      }
      border: 0;
      font-weight: 100;
      padding: .5rem;

      color: rgba(255, 206, 31, .8);
      &:hover {
        color: rgba(255, 206, 31, 1);
      }

      * {
        font-size: 1rem;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Settings.vue?12e67906